import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ArchivoService } from '../../../providers/archivo.service';
import { Observable, ReplaySubject, Observer } from 'rxjs';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { FileInputComponent, FileInput } from 'ngx-material-file-input';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss']
})
export class UploaderComponent implements OnInit {
  @Output() onUploadedAllFiles = new EventEmitter<boolean>();
  @Input('tabla') tabla: string;
  @ViewChild('fileInput') fileInput: FileInputComponent;
  fileInputData: FileInput;
  cargando: boolean[] = [];
  @Input() marginBottom: number = 16;

  // _observer: emite true cuando todos los archivos fueron subidos correctamente
  // si alguno no esta subido emite false
  private _observer: Observer<boolean>;

  private _opciones: Object;
  @Input() set opciones(value: Object) {
    this._opciones = value;
  }
  get opciones(): Object {
    return this._opciones;
  }

  private _archivos: File[];
  @Input() set archivos(value: File[]) {
    this._archivos = value;
  }
  get archivos(): File[] {
    return this._archivos;
  }

  private _multiple: boolean = true;
  @Input() set multiple(value: boolean) {
    this._multiple = value;
  }
  get multiple(): boolean {
    return this._multiple;
  }

  private _titulo: string = 'Archivos para cargar';
  @Input() set titulo(value: string) {
    this._titulo = value;
  }
  get titulo(): string {
    return this._titulo;
  }

  constructor(
    private _archivoSv: ArchivoService,
    public snackBar: MatSnackBar,
  ) {
    this._archivos = [];
  }

  ngOnInit() {
    if (!this.tabla) {
      throw "La variable Input 'tabla' es requerida";
    }
  }

  selectFiles() {
    this.fileInput.open();
  }

  selectedFilesChange(event) {
    if (event) {
      event.files.forEach(file => {
        if (this.archivos.find(archivo => file.name == archivo.name) == undefined) {
          if (!this.multiple) {
            this.archivos = [];
          }
          this.archivos.push(file);
          this._checkAllUploaded();
        }
      });
      this.fileInput.clear();
    }
  }

  remove(archivo) {
    this.archivos.splice(this.archivos.indexOf(archivo), 1);
    if(this.archivos.length==0)
    this.onUploadedAllFiles.emit(false);
  }

  uploadAll(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this._observer = observer;
      if (!this.archivos || this.archivos.length == 0) {
        this._checkAllUploaded();
      } else {
        if (this.cargando.length == 0) {
          this.archivos.forEach((archivo) => {
            this.upload(archivo);
          });
        }
      }
    });
  }

  upload(archivo) {
    if (archivo) {
      this._uploadFile(archivo).then(() => {
        this._checkAllUploaded();
      });
    }
  }

  /**
   * retorna true si ya se intentó subir el archivo
   */
  dirty(archivo): boolean {
    return typeof archivo['uploaded'] != 'undefined';
  }

  /**
   * retorna los archivos que fueron subidos sin errores
   */
  getUploadedFiles(): any[] {
    return this._archivos.filter(archivo => archivo['data'] != false);
  }

  private _uploadFile(archivo): Promise<boolean> {    
    return new Promise<boolean>(resolve => {
      if (archivo && archivo.uploaded) {
        resolve(true);
        return;
      }
      archivo['uploading'] = true;
      archivo['porcentaje'] = 0;
      archivo['invalid'] = false;
      archivo['uploaded'] = false;
      archivo['errorMsj'] = "";
      archivo['data'] = false;
      this.cargando.push(true);
      this._fileToBase64(archivo).subscribe((base64) => {
        this._archivoSv.cargar({
          file: {
            name: archivo.name,
            type: archivo.type,
            src: base64,
          },
          idCliente: localStorage.getItem('idCliente'),
          tabla: this.tabla,
          opciones: this.opciones
        }).subscribe(
          (event) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                archivo.porcentaje = +(event.loaded * 100 / event.total).toFixed(0);
                break;
              case HttpEventType.Response:
                const response = <HttpResponse<any>>event;
                if (response.status == 200 && response.ok) {
                  if (response.body && response.body.estado != 1) {
                    archivo.uploading = false;
                    archivo.invalid = true;
                    archivo.uploaded = false;
                    if (response.body && response.body.mensaje)
                      archivo.errorMsj = response.body.mensaje;
                    this.snackBar.open(archivo.errorMsj, 'Error', { duration: 3000,
                      panelClass: ['error'] // Asigna la clase 'error' al snackbar
                     }
                    );
                    resolve(false);
                  } else {
                    archivo.uploading = false;
                    archivo.invalid = false;
                    archivo.uploaded = true;
                    if (response.body && response.body.data)
                      archivo.data = response.body.data;
                    resolve(true);
                  }
                }
                break;
            }
          },
          (errr) => {
            console.log("err", errr);
            
            archivo.uploading = false;
            archivo.invalid = true;
            archivo.uploaded = false;
            resolve(false);
          },
          () => {
            this.cargando.pop();
          });
      });
    });
  }

  private _fileToBase64(fileToRead: File): Observable<any> {
    let base64Observable = new ReplaySubject<any>(1);
    let fileReader = new FileReader();
    fileReader.onload = () => {
      base64Observable.next(fileReader.result);
    };
    fileReader.readAsDataURL(fileToRead);
    return base64Observable;
  }

  /**
  * si todos los archivos estan subidos, emite true
  * si no hay archivos para subir también emite true
  */
  private _checkAllUploaded() {   
    this.onUploadedAllFiles.emit(true); 
    if (!this.archivos || this.archivos.length == 0) {
      this.onUploadedAllFiles.emit(true);
      if (this._observer)
        this._observer.next(true);
      this._observer.complete();
    }
    else if (this.archivos.filter((archivo) => archivo['uploaded']).length == this.archivos.length) {
      this.onUploadedAllFiles.emit(true);
      if (this._observer)
        this._observer.next(true);
      this._observer.complete();
    } else {
      if (this._observer)
        this._observer.next(false);
    }
  }
}
